module.exports = __webpack_public_path__ + "Medical-gray.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=[name].[ext]!./app/images/Medical-gray.png
// module id = ./node_modules/file-loader/index.js?name=[name].[ext]!./app/images/Medical-gray.png
// module chunks = 10